:host {
  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
}

.stzh-checkboxgroup {
  @include input-description;
  margin: 0;
  padding: 0;
  border: none;

  &__fields {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: space("medium");
  }

  &__legend {
    @include font("heavy");
    @include fontSize("micro");
    color: $headingColor;
    padding: 0;
    margin-bottom: space("xsmall");
  }

  &--hide-legend &__legend {
    @include visuallyhidden;
  }

  &--direction-horizontal &__fields {
    flex-wrap: wrap;
    flex-direction: row;
    row-gap: space("medium");
    column-gap: space("xxlarge");
  }
}
